import { render, staticRenderFns } from "./extract.vue?vue&type=template&id=04bfb496"
import script from "./extract.vue?vue&type=script&lang=js"
export * from "./extract.vue?vue&type=script&lang=js"
import style0 from "./extract.vue?vue&type=style&index=0&id=04bfb496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports